import {
    IRestrictedAccountObjectArgs,
    RestrictedAccountObject
} from '../restricted-account-object/restricted-account-object.model';

export interface IReportLayoutArgs extends IRestrictedAccountObjectArgs {
    title?: string;
    description?: string;
    entryPoint?: string;
    jobType?: string;
    localFileSystemPath?: string;
}

const defaults = () => ({
    title: '',
    description: '',
    entryPoint: '',
    jobType: '',
    localFileSystemPath: ''
} as IReportLayoutArgs);

export class ReportLayout extends RestrictedAccountObject {
    title: string;
    description: string;
    entryPoint: string;
    jobType: string;
    localFileSystemPath: string;

    constructor(data?: IReportLayoutArgs) {
        super({...defaults(), ...data});
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/report-layout/report-layout.model.ts